export default () => {
    let indicators = [];

    return {
        isSetIndicator:  (id) => indicators.includes(id),
        addIndicator:    (id) => indicators.push(id),
        removeIndicator: (id) => indicators = indicators.filter((indicator) => indicator !== id),
    };
};
